<div *ngFor="let kodJazykIteracia of kodJazykIN.split(', '); let index = index;">

  <app-header-polozka
    [typ]="typZaznamuTextu"
    [kodJazyk]="kodJazykIteracia"
    [formularFormGroup]="formularFormGroup"
    [zobrazitCopyButton]="index === 0 && kodJazykIN.length > 2">
  </app-header-polozka>

  <div *ngIf="typZaznamuTextu.opakovanie === 'A' || jeOpakovaniePodprogramu; else neopakovanaPolozka"
    formArrayName="name_{{typZaznamuTextu.id}}_{{kodJazykIteracia}}">

    <!-- OPAKOVANE POLOZKY -->
    <div *ngFor="let controlFromArray of mapaJazykovAFormArrays.get(kodJazykIteracia)?.controls; let i = index; last as last">


      <!-- SWAPOVACI BUTTON -->
      <div class="d-flex mb-1">
        <button *ngIf="i > 0 && i < (mapaJazykovAFormArrays.get(kodJazykIteracia)?.controls?.length ?? 0)"
          class="ms-auto"
          style="margin-top: -13px;"
          mat-icon-button
          type="button"
          (click)="vymenPolozky(i, kodJazykIteracia)"
          [matTooltip]="getVymenitObsahPoloziekTooltip()"
          aria-label="Vymeniť obsah položiek">
          <mat-icon>swap_vert</mat-icon>
        </button>
      </div>

      <div *ngIf="typZaznamuTextu.vazba === appStateService.VAZBA_STUPEN_TYP_STUDIA
          && index === 0"
        class="d-flex justify-content-end">

        <app-stupen-typ-studia
          [idTyp]="typZaznamuTextu.id"
          [poradieOpakovanejPolozky]="i+1">
        </app-stupen-typ-studia>

      </div>


      <div class="d-flex flex-row">

        <div *ngIf="typZaznamuTextu.opakovanie === 'A'" class="mt-3 me-2 h5">{{i+1}}.</div>

        <mat-form-field appearance="fill">
          <mat-label i18n>Vyberte možnosť</mat-label>
          <mat-select
            id="name_{{typZaznamuTextu.id}}_{{i}}_{{kodJazykIteracia}}"
            [formControlName]="i"
            matTooltip="{{getTooltip(kodJazykIteracia, i)}}">
            <mat-option></mat-option>
            <mat-option *ngFor="let polozka of getPolozkyCiselnika(kodJazykIteracia)"
              value="{{polozka}}">
              {{polozka}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div *ngIf="last && typZaznamuTextu.opakovanie === 'A'" class="mt-2 ms-2">
          <button mat-mini-fab color="primary" type="button" (click)="pridatPolozku(kodJazykIteracia)"
              [matTooltip]="getPridatPolozkuTooltip()"
              [disabled]="typZaznamuTextu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
            <mat-icon>add</mat-icon>
          </button>
        </div>

      </div>

      <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)
          && appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu, kodJazykIteracia, i)"
        class="mb-2 pomocny-text-podprogramy"
        [ngClass]="{'ms-4': typZaznamuTextu.opakovanie === 'A', 'ms-1': typZaznamuTextu.opakovanie !== 'A'}">

        {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu, kodJazykIteracia, i)}}
      </div>

      <!-- POLICKO PRE STUD. PROGRAMY ZAZNAMU TEXTU PODPROGRAMU A BUTTON PRE ICH VYBER -->
      <div *ngIf="appStateService.zobrazitButtonOpakovaniaPrePodprogram(typZaznamuTextu)"
        [ngClass]="{'mb-5': !last}">
        <app-studijne-programy-zaznamu
          [typZaznamuTextu]="typZaznamuTextu"
          [kodJazyk]="kodJazykIteracia"
          [poradiePolozkyVoFormulari]="i+1"
          [mapaJazykovAFormArrays]="mapaJazykovAFormArrays">
        </app-studijne-programy-zaznamu>
      </div>

    </div>

  </div>

  <ng-template #neopakovanaPolozka>
    <div *ngIf="!typZaznamuTextu.idSkupina || typZaznamuTextu.idSkupina === 0;else skupinovaPolozka">

      <div *ngIf="typZaznamuTextu.uroven === 2
        && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty"
          class="text-warning" i18n>
          *položka je editovateľná len z úrovne fakulty
      </div>

      <mat-form-field appearance="fill">
        <mat-label i18n>Vyberte možnosť</mat-label>
        <mat-select
          id="name_{{typZaznamuTextu.id}}_{{kodJazykIteracia}}"
          formControlName="name_{{typZaznamuTextu.id}}_{{kodJazykIteracia}}"
          matTooltip="{{getTooltip(kodJazykIteracia)}}">
          <mat-option></mat-option>
          <mat-option *ngFor="let polozka of getPolozkyCiselnika(kodJazykIteracia)"
            value="{{polozka}}">
            {{polozka}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- pomocny text pre polozku podprogramu -->
      <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)"
        class="ms-1 mb-2 pomocny-text-podprogramy">

        {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu)}}
      </div>

    </div>

    <ng-template #skupinovaPolozka>
      <div formArrayName="name_{{typZaznamuTextu.idSkupina}}_{{kodJazykIteracia}}">
        <mat-form-field appearance="fill">
          <mat-label i18n>Vyberte možnosť</mat-label>
          <mat-select
            id="name_{{typZaznamuTextu.id}}_{{typZaznamuTextu.idSkupina}}_{{indexPolozkyVoFormulari}}_{{kodJazykIteracia}}"
            [formControlName]="indexPolozkyVoFormulari"
            matTooltip="{{getTooltip(kodJazykIteracia, indexPolozkyVoFormulari)}}">
            <mat-option></mat-option>
            <mat-option *ngFor="let polozka of getPolozkyCiselnika(kodJazykIteracia)"
              value="{{polozka}}">
              {{polozka}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- pomocny text pre polozku podprogramu -->
        <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)"
          class="ms-1 mb-2 pomocny-text-podprogramy">

          {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu)}}
        </div>

      </div>
    </ng-template>

  </ng-template>

</div>
